import { myApi } from '../../config/axiosConfig';

// =========================================
// BUSCAR INCIDENCIAS
// =========================================

export const getIncidencias = async () => {

    const response = await myApi.get('/reasons');

    return response.data;

}

// =========================================
// BUSCAR CATALOGO DE INCIDENCIAS
// =========================================

export const getCatalogoIncidencias = async () => {

    const response = await myApi.get('/reasons/select');

    return response.data;

}